import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, FormGroup, FormControlLabel, Checkbox, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Formik } from "formik";
import * as Yup from "yup";
import { useAddActionTrackerMutation } from "store/slices/apis/actionTrackerSlice";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import Select from "react-select";
import { actionCategories, actionContacts, actionDecisionVsOperational, actionPriority, actionResponsible, actionSource, actionStatus } from "helpers/actionTrackerOptions";
import { useGetAllProjectsQuery } from "store/slices/apis/projectApiSlice";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import { mapAndSortAlphabetically } from "utils/mapSortHelper";

const rightLabelStyle = {
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "16px",
    color: "#475569",
    fontFamily: "Outfit, sans-serif",
};

const rightTextStyle = {
    "& .MuiInputBase-input": {
        fontWeight: 400,
        fontSize: "13px",
        lineHeight: "18px",
        letterSpacing: "0.16px",
        color: "#0A0A0C",
        fontFamily: "Outfit, sans-serif",
    },
};

const labelTextStyle = {
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "16px",
    color: "#475569",
    fontFamily: "Outfit, sans-serif",
    mb: 1,
    mt: 1,
};

const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>

);
const AddActionTracker = (props) => {
    const { open, handleClose, actionContact } = props;
    const { projectId: paramProjectId } = useParams();
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const dispatch = useDispatch();
    const projectType = localStorage.getItem("projectType") || "";
    const module = "ActionTracker";
    const [addActionTrackerResFun, addActionTrackerRes] = useAddActionTrackerMutation();
    const { data, error, isLoading, isFetching: isProjectFething, refetch } = useGetAllProjectsQuery(projectType);

    const effectiveProjectId = paramProjectId || selectedProjectId;

    const { data: actionSubProjectRes } = useGetMasterDataQuery(
        {
            module: module,
            category: 'SubProject',
            ProjectId: effectiveProjectId,
        },
        {
            skip: !effectiveProjectId
        }
    );

    const subProjectData = actionSubProjectRes?.data || [];
    const actionSubProjects = mapAndSortAlphabetically(subProjectData);
    const hasSubProjects = actionSubProjects?.length > 0;

    const { data: actionCategoriesRes } = useGetMasterDataQuery({ module: module, category: 'Category', ProjectId: paramProjectId });

    const categoryData = actionCategoriesRes?.data || [];
    const actionCategories = mapAndSortAlphabetically(categoryData);
    // const actionCategories = (categoryData || []).map(p => ({
    //     value: p?.value,
    //     label: p?.value,
    // }));

    const { data: actionSourceRes } = useGetMasterDataQuery({ module: module, category: 'Source', ProjectId: paramProjectId });

    const actionSourceData = actionSourceRes?.data || [];
    const actionSource = mapAndSortAlphabetically(actionSourceData);
    // const actionSource = (actionSourceData || []).map(p => ({
    //     value: p?.value,
    //     label: p?.value,
    // }));

    const { data: actionResponsibleRes } = useGetMasterDataQuery({ module: module, category: 'Owner', ProjectId: paramProjectId });

    const actionResponsibleData = actionResponsibleRes?.data || [];
    const actionResponsible = mapAndSortAlphabetically(actionResponsibleData);
    // const actionResponsible = (actionResponsibleData || []).map(p => ({
    //     value: p?.value,
    //     label: p?.value,
    // }));

    const { data: actionPriorityRes } = useGetMasterDataQuery({ module: module, category: 'Priority', ProjectId: paramProjectId });

    const actionPriorityData = actionPriorityRes?.data || [];
    const actionPriority = (actionPriorityData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: actionStatusRes } = useGetMasterDataQuery({ module: module, category: 'Status', ProjectId: paramProjectId });

    const actionStatusData = actionStatusRes?.data || [];
    const actionStatus = (actionStatusData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: actionDecisionVsOperationalRes } = useGetMasterDataQuery({ module: module, category: 'DecisionVsOperational' });

    const actionDecisionVsOperationalData = actionDecisionVsOperationalRes?.data || [];
    const actionDecisionVsOperational = (actionDecisionVsOperationalData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const projectData = data?.data || [];
    const projectOptions = (projectData || []).map(p => ({
        value: p?.projectId,
        label: p?.projectName,
        projectType: p?.projectType, // optional, if you want it later
    }));

    const [formData, setFormData] = useState({
        subProject: "",
        topic: "",
        decisionVsOperational: "",
        source: "",
        responsible: "",
        assignedTo: "",
        // date_created: "",
        dueDate: "",
        priority: "",
        status: "",
        closedDate: "",
        // revisedDueDate: null,
        comment: "",
        description: "",
        projectId: "",
        criticality: 'string',
        isCritical: false
    });


    const getValidationSchema = (paramProjectId) =>
        Yup.object({

            topic: Yup.string().required("Category field is required"),

            decisionVsOperational: Yup.string().required(
                "Decision Vs Operational field is required"
            ),

            source: Yup.string().required("Source field is required"),

            responsible: Yup.string().required("Responsible Owner field is required"),

            assignedTo: Yup.string().required("Assigned To field is required"),

            dueDate: Yup.date().required("Due Date field is required"),

            priority: Yup.string().required("Priority field is required"),

            status: Yup.string().required("Status field is required"),

            description: Yup.string().required("Description field is required"),

            projectId: Yup.string().when([], {
                is: () => !paramProjectId,
                then: (schema) => schema.required("Project is required"),
                otherwise: (schema) => schema.notRequired(),
            }),

            closedDate: Yup.string().when("status", {
                is: "Closed",
                then: (schema) =>
                    schema.required("Closed Date is required"),
                otherwise: (schema) =>
                    schema.notRequired(),
            }),
        });


    // const validationSchema = Yup.object({
    //     topic: Yup.string().required("Category field is required"),
    //     decisionVsOperational: Yup.string().required("Decision Vs Operational field is required"),
    //     source: Yup.string().required("Source field is required"),
    //     responsible: Yup.string().required("Responsible Owner field is required"),
    //     assignedTo: Yup.string().required("Assigned To field is required"),
    //     // date_created: Yup.date().required("Date Created field is required"),
    //     dueDate: Yup.date().required("Due Date field is required"),
    //     priority: Yup.string().required("Priority field is required"),
    //     status: Yup.string().required("Status field is required"),
    //     // revisedDueDate: Yup.date().required("Revised Due Date  field is required"),
    //     // comment: Yup.string().required("Comment field is required"),
    //     description: Yup.string().required("Description field is required"),
    // });

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {

        let revisedDueDate = null, dueDate = "", closedDate = null;

        if (values?.revisedDueDate) {
            revisedDueDate = moment
                .utc(values?.revisedDueDate, 'YYYY-MM-DD')
                .format('YYYY-MM-DDTHH:mm:ss[Z]');
        }

        if (values?.dueDate) {
            dueDate = moment
                .utc(values?.dueDate, 'YYYY-MM-DD')
                .format('YYYY-MM-DDTHH:mm:ss[Z]');
        }

        if (values?.closedDate) {
            closedDate = moment
                .utc(values?.closedDate, 'YYYY-MM-DD')
                .format('YYYY-MM-DDTHH:mm:ss[Z]');
        }

        let modifiyValues = {
            ...values, dueDate, revisedDueDate, closedDate,
            projectId: paramProjectId ?? values.projectId,
        }
        addActionTrackerResFun(modifiyValues);
    };

    React.useEffect(() => {
        if (addActionTrackerRes?.isSuccess) {
            if (addActionTrackerRes?.data?.status?.toLowerCase() == 'success') {
                openNotification(addActionTrackerRes?.data?.message, 'success')
                handleClose();
            } else {
                openNotification(addActionTrackerRes?.data?.message, 'error')
            }
        }
    }, [addActionTrackerRes?.isSuccess]);


    React.useEffect(() => {
        if (addActionTrackerRes?.isError) {
            if (addActionTrackerRes?.error?.data?.status?.toLowerCase() == 'fail') {
                openNotification(addActionTrackerRes?.error?.data?.message, 'error')
            } else {
                openNotification(addActionTrackerRes?.error?.data?.message ?? 'Something went wrong!', 'error')
            }
            // cancel();
        }
    }, [addActionTrackerRes?.isError]);

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const subProjectGridSize = paramProjectId ? { xs: 12, md: 12 } : { xs: 12, md: 6 };

    return (
        <Dialog open={open}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: { borderTopLeftRadius: "3px", borderTopRightRadius: "3px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#FFFFFF",
                px: 3,
                py: 1.75,
                width: "100%",
            }}>
                <Box>
                    <Typography sx={{ fontWeight: 650, fontSize: "18px", lineHeight: "24px", color: "#0F172A", fontFamily: "Outfit, sans-serif" }}>
                        Create Action
                    </Typography>
                    <Typography sx={{ mt: 0.25, fontSize: "11px", lineHeight: "15px", color: "#64748B" }}>
                        Capture ownership, due dates, priority, and delivery context.
                    </Typography>
                </Box>
                <IconButton aria-label="Close" onClick={handleClose} size="small" sx={{ borderRadius: "3px", color: "#64748B" }}>
                    <CloseIcon fontSize="small" />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ bgcolor: "#F8FAFC", px: 3, py: 2.5 }}>
                <Formik
                    initialValues={formData}
                    validationSchema={getValidationSchema(paramProjectId)}
                    onSubmit={handleSubmit}
                // context={{ projectId }}
                >
                    {({ values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        setFieldTouched,
                        setTouched, }) => (
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2} sx={{ bgcolor: "#FFFFFF", border: "1px solid #E2E8F0", borderRadius: "3px", p: 2 }}>
                                <Grid size={12}>
                                    <Typography sx={{ fontSize: "12px", fontWeight: 650, color: "#0F172A", textTransform: "uppercase" }}>
                                        Action details
                                    </Typography>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12 }}>
                                    <Box sx={{width:'20%'}}>
                                        <FormGroup>
                                            <FormControlLabel
                                                sx={{
                                                    "& .MuiFormControlLabel-label": {
                                                        fontWeight: 500,
                                                        fontSize: "12px",
                                                        lineHeight: "100%",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                    }
                                                }}
                                                control={
                                                    <Checkbox checked={values?.isCritical}
                                                        onChange={(e) => {
                                                            // console.log(e.target.checked);
                                                            setFieldValue("isCritical", e.target.checked);
                                                        }}
                                                    />} label="Mark as critical" />
                                        </FormGroup>
                                    </Box>
                                </Grid>
                                {paramProjectId == undefined &&
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                            Select Project
                                        </Typography>
                                        <Select
                                            name="projects"
                                            options={projectOptions}
                                            value={projectOptions.find(opt => opt?.value === values?.projectId) || null}
                                            onChange={(option) => {
                                                setFieldValue("projectId", option?.value);
                                                setSelectedProjectId(option?.value);
                                            }}
                                            onBlur={() => setFieldTouched("projectId", true)}
                                            placeholder="Select Project"
                                        />
                                        {touched?.projectId && errors?.projectId && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                                {errors?.projectId}
                                            </Typography>
                                        )}
                                    </Grid>
                                }

                                {hasSubProjects && (
                                    <Grid size={subProjectGridSize}>
                                        <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                            Select Sub Project
                                        </Typography>
                                        <Select
                                            name="subProject"
                                            options={actionSubProjects}
                                            value={actionSubProjects.find(opt => opt.value === values.subProject) || null}
                                            onChange={(option) => setFieldValue("subProject", option.value)}
                                            onBlur={() => setFieldTouched("subProject", true)}
                                            placeholder="Select Sub Project"
                                        />
                                        {touched.subProject && errors.subProject && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                                {errors.subProject}
                                            </Typography>
                                        )}
                                    </Grid>
                                )}

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                        Select Category
                                    </Typography>
                                    <Select
                                        name="topic"
                                        options={actionCategories}
                                        value={actionCategories.find(opt => opt.value === values.topic) || null}
                                        onChange={(option) => setFieldValue("topic", option.value)}
                                        onBlur={() => setFieldTouched("topic", true)}
                                        placeholder="Select Category"
                                    />
                                    {touched.topic && errors.topic && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                            {errors.topic}
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                        Select Decision Vs Operational
                                    </Typography>
                                    <Select
                                        name="decisionVsOperational"
                                        options={actionDecisionVsOperational}
                                        value={actionDecisionVsOperational.find(opt => opt.value === values.decisionVsOperational) || null}
                                        onChange={(option) => setFieldValue("decisionVsOperational", option.value)}
                                        onBlur={() => setFieldTouched("decisionVsOperational", true)}
                                        placeholder="Select Decision Vs Operational"
                                    />
                                    {touched.decisionVsOperational && errors.decisionVsOperational && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                            {errors.decisionVsOperational}
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid size={12} sx={{ mt: 0.5, pt: 1.5, borderTop: "1px solid #E2E8F0" }}>
                                    <Typography sx={{ fontSize: "12px", fontWeight: 650, color: "#0F172A", textTransform: "uppercase" }}>
                                        Ownership and schedule
                                    </Typography>
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                        Select Source
                                    </Typography>
                                    <Select
                                        name="source"
                                        options={actionSource}
                                        value={actionSource.find(opt => opt.value === values.source) || null}
                                        onChange={(option) => setFieldValue("source", option.value)}
                                        onBlur={() => setFieldTouched("source", true)}
                                        placeholder="Select Source"
                                    />
                                    {touched.source && errors.source && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                            {errors.source}
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                        Select Responsible / Owner
                                    </Typography>
                                    <Select
                                        name="responsible"
                                        options={actionResponsible}
                                        value={actionResponsible.find(opt => opt.value === values.responsible) || null}
                                        onChange={(option) => setFieldValue("responsible", option.value)}
                                        onBlur={() => setFieldTouched("responsible", true)}
                                        placeholder="Select Responsible / Owner"
                                    />
                                    {touched.responsible && errors.responsible && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                            {errors.responsible}
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Assigned To</Typography>
                                    <Select
                                        name="assignedTo"
                                        isMulti
                                        options={actionContact}
                                        value={
                                            values.assignedTo
                                                ? values.assignedTo?.split(",").map(v => actionContact?.find(opt => opt?.value === v)).filter(Boolean)
                                                : []
                                        }
                                        onChange={(selectedOptions) => {
                                            const labels = selectedOptions?.map(opt => opt?.value).join(",");
                                            setFieldValue("assignedTo", labels);
                                        }}
                                        onBlur={() => setFieldTouched("assignedTo", true)}
                                        placeholder="Select Assigned To"
                                    />
                                    {touched.assignedTo && errors.assignedTo && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                            {errors.assignedTo}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                        Due Date
                                    </Typography>
                                    <TextField
                                        type="date"
                                        name="dueDate"
                                        value={values.dueDate}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onClick={(e) => {
                                            // Trigger the native date picker
                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                            if (input) input.showPicker?.();
                                        }}
                                        fullWidth
                                        sx={{
                                            ...rightTextStyle,
                                            "& input::-webkit-calendar-picker-indicator": {
                                                display: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& input[type='date']": {
                                                appearance: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    border: "none",
                                                },
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                >
                                                    {calenderSVG}
                                                </Box>
                                            ),
                                            sx: {
                                                backgroundColor: "#fff",
                                                border: '1px solid',
                                                borderColor: 'hsl(0, 0%, 80%)',
                                                height: "40px",
                                                width: { xs: "100%", md: "100%" },
                                                borderRadius: "3px",
                                            },
                                        }}
                                    />
                                    {touched.dueDate && errors.dueDate && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                            {errors.dueDate}
                                        </Typography>
                                    )}
                                </Grid>
                                {/* <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                        Revised Due Date
                                    </Typography>
                                    <TextField
                                        type="date"
                                        name="revisedDueDate"
                                        value={values?.revisedDueDate}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onClick={(e) => {
                                            // Trigger the native date picker
                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                            if (input) input.showPicker?.();
                                        }}
                                        fullWidth
                                        sx={{
                                            ...rightTextStyle,
                                            "& input::-webkit-calendar-picker-indicator": {
                                                display: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& input[type='date']": {
                                                appearance: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    border: "none",
                                                },
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                >
                                                    {calenderSVG}
                                                </Box>
                                            ),
                                            sx: {
                                                backgroundColor: "#fff",
                                                border: '1px solid',
                                                borderColor: 'hsl(0, 0%, 80%)',
                                                height: "40px",
                                                width: { xs: "100%", md: "100%" },
                                                borderRadius: "3px",
                                            },
                                        }}
                                    />
                                    {touched.revisedDueDate && errors.revisedDueDate && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.revisedDueDate}
                                        </Typography>
                                    )}
                                </Grid> */}
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                        Select Priority
                                    </Typography>
                                    <Select
                                        name="priority"
                                        options={actionPriority}
                                        value={actionPriority.find(opt => opt.value === values.priority) || null}
                                        onChange={(option) => setFieldValue("priority", option.value)}
                                        onBlur={() => setFieldTouched("priority", true)}
                                        placeholder="Select Priority"
                                    />
                                    {touched.priority && errors.priority && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                            {errors.priority}
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid size={{ xs: 12, md: values.status === "Closed" ? 6 : 12 }}>
                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                        Select Status
                                    </Typography>
                                    <Select
                                        name="status"
                                        options={actionStatus}
                                        value={actionStatus.find(opt => opt.value === values.status) || null}
                                        onChange={(option) => {
                                            setFieldValue("status", option.value);

                                            if (option.value !== "Closed") {
                                                setFieldValue("closedDate", "");
                                            }
                                        }}
                                        onBlur={() => setFieldTouched("status", true)}
                                        placeholder="Select Status"
                                    />
                                    {touched.status && errors.status && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                            {errors.status}
                                        </Typography>
                                    )}
                                </Grid>

                                {values.status === "Closed" && (
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                            Closed Date
                                        </Typography>
                                        <TextField
                                            type="date"
                                            name="closedDate"
                                            value={values.closedDate}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            onClick={(e) => {
                                                // Trigger the native date picker
                                                const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                if (input) input.showPicker?.();
                                            }}
                                            fullWidth
                                            sx={{
                                                ...rightTextStyle,
                                                "& input::-webkit-calendar-picker-indicator": {
                                                    display: "none",
                                                    WebkitAppearance: "none",
                                                },
                                                "& input[type='date']": {
                                                    appearance: "none",
                                                    WebkitAppearance: "none",
                                                },
                                                "& .MuiOutlinedInput-root": {
                                                    "& fieldset": {
                                                        border: "none",
                                                    },
                                                },
                                            }}
                                            InputProps={{
                                                startAdornment: (
                                                    <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                    >
                                                        {calenderSVG}
                                                    </Box>
                                                ),
                                                sx: {
                                                    backgroundColor: "#fff",
                                                    border: '1px solid',
                                                    borderColor: 'hsl(0, 0%, 80%)',
                                                    height: "40px",
                                                    width: { xs: "100%", md: "100%" },
                                                    borderRadius: "3px",
                                                },
                                            }}
                                        />
                                        {touched.closedDate && errors.closedDate && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                                {errors.closedDate}
                                            </Typography>
                                        )}
                                    </Grid>
                                )}

                                <Grid size={12} sx={{ mt: 0.5, pt: 1.5, borderTop: "1px solid #E2E8F0" }}>
                                    <Typography sx={{ fontSize: "12px", fontWeight: 650, color: "#0F172A", textTransform: "uppercase" }}>
                                        Notes and context
                                    </Typography>
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Description</Typography>
                                    <TextField
                                        fullWidth
                                        name="description"
                                        value={values.description}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        multiline
                                        rows={3}
                                        placeholder="Enter Description"
                                        InputProps={{
                                            sx: {
                                                // height: "50px",
                                                borderRadius: "3px",
                                                backgroundColor: "#fff",

                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "13px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },

                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "13px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                    {touched.description && errors.description && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                            {errors.description}
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Comment/ Identified Challenges/ Problems</Typography>
                                    <TextField
                                        fullWidth
                                        name="comment"
                                        value={values.comment}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        multiline
                                        rows={3}
                                        placeholder="Enter Comment/ Identified Challenges/ Problems"
                                        InputProps={{
                                            sx: {
                                                // height: "50px",
                                                borderRadius: "3px",
                                                backgroundColor: "#fff",

                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "13px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },

                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "13px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid size={12} sx={{ mt: 0.5, pt: 2, borderTop: "1px solid #E2E8F0" }}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Button onClick={handleClose}
                                            sx={{
                                                textTransform: "none",
                                                color: "#475569",
                                                fontSize: "13px",
                                                lineHeight: "100%",
                                                fontFamily: "Outfit, sans-serif",
                                                borderRadius: "3px",
                                                fontWeight: 500,
                                                px: 2,
                                                py: 1,
                                            }}>
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            loading={addActionTrackerRes?.isLoading}
                                            sx={{
                                                backgroundColor: "#2563EB",
                                                borderRadius: "3px",
                                                textTransform: "none",
                                                fontWeight: 500,
                                                fontSize: "13px",
                                                lineHeight: "100%",
                                                fontFamily: "Outfit, sans-serif",
                                                color: "#FFFFFF",
                                                px: 2.25,
                                                py: 1,
                                            }}
                                        >
                                            Save
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    );
};

export default AddActionTracker;
